import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 14s1.5 2 4 2 4-2 4-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "9", x2: "9.01", y1: "9", y2: "9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "15.01", y1: "9", y2: "9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Smile";
const Smile = memo(themed(Icon));
export {
  Smile
};
//# sourceMappingURL=smile.js.map
